import { CLOSE_MAX_PRODUCT_QUANTITY_TOOLTIP } from '@shopDetails/actionTypes';

const closeMaxProductQuantityTooltip = () => ({
  type: CLOSE_MAX_PRODUCT_QUANTITY_TOOLTIP,
});

export default closeMaxProductQuantityTooltip;
